/* This code is importing the `createContext` function from the `react` library and assigning it to a
variable called `SearchContext`. It then exports `SearchContext` as the default export of this
module. */
import React, { createContext } from 'react'

const SearchContext = createContext();
export default SearchContext;